import { render, staticRenderFns } from "./Pasien.vue?vue&type=template&id=4d5d2e9b&"
import script from "./Pasien.vue?vue&type=script&lang=js&"
export * from "./Pasien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports